// src/index.jsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';  // ← 追加
import axios from 'axios';
import './main.css';
import App from './App';

// ===== QueryClient 設定 =====
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,      // 5分間はキャッシュを新鮮とみなす
      retry: 1,                       // リトライ1回
      refetchOnWindowFocus: false,    // フォーカス時の自動リフェッチ無効
    },
  },
});

// ===== axios リフレッシュトークン設定 =====
const API_URL = import.meta.env.VITE_API_URL;

// 1️⃣ リクエスト時：トークンを自動付与
axios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 2️⃣ レスポンス時：401なら自動リフレッシュ
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve()));
  failedQueue = [];
};

axios.interceptors.response.use(
  (res) => res,  // 成功時はそのまま返す
  async (err) => {
    // ↓ 401エラー かつ まだリトライしていない場合
    const originalRequest = err.config;

    if (err?.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => axios(originalRequest));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refresh = sessionStorage.getItem('refreshToken');
        if (!refresh) throw new Error('No refresh token');
        // リフレッシュトークンで新しいアクセストークン取得
        const res = await axios.post(`${API_URL}/api/token/refresh/`, { refresh });
        sessionStorage.setItem('accessToken', res.data.access);
        originalRequest.headers.Authorization = `Bearer ${res.data.access}`;

        processQueue(null);
        return axios(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError);
        sessionStorage.clear();
        window.location.href = '/login';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(err);
  }
);
// ===== ここまで =====

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>  {/* ← 追加 */}
      <HelmetProvider>
        <Router>
          <App />
        </Router>
      </HelmetProvider>
    </QueryClientProvider>  {/* ← 追加 */}
  </React.StrictMode>
);